const initialState = {
  loading: false,
  points: parseInt(localStorage.getItem('clientPoints')) || 0,
  rewards: [],
  history: [],
  vouchers: [],
  stats: {
    totalEarned: 0,
    totalSpent: 0,
    rewardsClaimed: 0,
    lastUpdated: null
  },
  error: null,
  lastAddedPoints: 0,
  lastTransaction: null
};

export default function pointsReducer(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case 'GET_POINTS_REQUEST':
    case 'ADD_POINTS_REQUEST':
    case 'GET_REWARDS_REQUEST':
    case 'REDEEM_REWARD_REQUEST':
    case 'GET_HISTORY_REQUEST':
      return {
        ...state,
        loading: true,
        error: null
      };

    case 'GET_POINTS_SUCCESS':
      return {
        ...state,
        loading: false,
        points: payload.points || state.points,
        stats: {
          totalEarned: payload.stats?.totalEarned || 0,
          totalSpent: payload.stats?.totalSpent || 0,
          rewardsClaimed: payload.stats?.rewardsClaimed || 0,
          lastUpdated: payload.stats?.lastUpdated || new Date().toISOString()
        }
      };

    case 'ADD_POINTS_SUCCESS':
      return {
        ...state,
        loading: false,
        points: payload.newPoints || state.points,
        lastAddedPoints: payload.pointsAdded || 0,
        lastTransaction: payload.transaction || null,
        stats: {
          ...state.stats,
          totalEarned: state.stats.totalEarned + (payload.pointsAdded || 0),
          lastUpdated: new Date().toISOString()
        }
      };

    case 'GET_REWARDS_SUCCESS':
      return {
        ...state,
        loading: false,
        rewards: Array.isArray(payload) ? payload : []
      };

    case 'REDEEM_REWARD_SUCCESS':
      const pointsCost = payload.reward?.pointsCost || 0;
      return {
        ...state,
        loading: false,
        points: state.points - pointsCost,
        lastTransaction: payload.transaction || null,
        stats: {
          ...state.stats,
          totalSpent: state.stats.totalSpent + pointsCost,
          rewardsClaimed: state.stats.rewardsClaimed + 1,
          lastUpdated: new Date().toISOString()
        }
      };

    case 'GET_HISTORY_SUCCESS':
      return {
        ...state,
        loading: false,
        history: Array.isArray(payload) ? payload : []
      };

    case 'GET_POINTS_FAIL':
    case 'ADD_POINTS_FAIL':
    case 'GET_REWARDS_FAIL':
    case 'REDEEM_REWARD_FAIL':
    case 'GET_HISTORY_FAIL':
      return {
        ...state,
        loading: false,
        error: payload
      };

    default:
      return state;
  }
}